import { render, staticRenderFns } from "./pass.index.vue?vue&type=template&id=321aeda6&scoped=true&"
import script from "./pass.index.vue?vue&type=script&lang=js&"
export * from "./pass.index.vue?vue&type=script&lang=js&"
import style0 from "./pass.index.vue?vue&type=style&index=0&id=321aeda6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321aeda6",
  null
  
)

export default component.exports